import React from "react";
// @ts-ignore
import Information from "@fdr/static-ui/SvgImages/Information";
import {
  ErrorDescription,
  ErrorDescriptionEnum
} from "@tvg/ts-types/GeoComply";
import {
  DescriptionWrapper,
  Title,
  DescriptionContent,
  DescriptionItem
} from "./styled-components";

export interface Props extends ErrorDescription {
  qaLabel?: string;
}

const GeoComplyErrorDescription = ({
  qaLabel = "geoComplyError-description",
  type = ErrorDescriptionEnum.TEXT,
  title,
  messages
}: Props) => (
  <DescriptionWrapper data-qa-label={qaLabel}>
    {title && <Title data-qa-label={`${qaLabel}-title`}>{title}</Title>}
    {messages && (
      <DescriptionContent type={type}>
        {messages.map((message, index) => (
          <DescriptionItem
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            data-qa-label={`${qaLabel}-item-${index}`}
            isListItem={type === ErrorDescriptionEnum.STEPS}
          >
            {type === ErrorDescriptionEnum.TIPS && <Information />}
            {message}
          </DescriptionItem>
        ))}
      </DescriptionContent>
    )}
  </DescriptionWrapper>
);

export default GeoComplyErrorDescription;
